import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";

export const ProfileTab = ({ profile }) => (
  <Card className="bg-white border-[#E2E8E0]">
    <CardHeader>
      <CardTitle className="text-[#1A2E12]">Profile Details</CardTitle>
    </CardHeader>
    <CardContent>
      {profile && (
        <div className="space-y-4 max-w-md">
          <div>
            <Label className="text-sm text-[#5C6B57]">Name</Label>
            <p className="font-medium text-[#1A2E12]">{profile.name}</p>
          </div>
          <div>
            <Label className="text-sm text-[#5C6B57]">Email</Label>
            <p className="font-medium text-[#1A2E12]">{profile.email}</p>
          </div>
          {profile.phone && (
            <div>
              <Label className="text-sm text-[#5C6B57]">Phone</Label>
              <p className="font-medium text-[#1A2E12]">{profile.phone}</p>
            </div>
          )}
          {profile.address && (
            <div>
              <Label className="text-sm text-[#5C6B57]">Address</Label>
              <p className="font-medium text-[#1A2E12]">{profile.address}</p>
            </div>
          )}
          {profile.postcode && (
            <div>
              <Label className="text-sm text-[#5C6B57]">Postcode</Label>
              <p className="font-medium text-[#1A2E12]">{profile.postcode}</p>
            </div>
          )}
          <div className="pt-4">
            <p className="text-sm text-[#5C6B57]">
              Member since{" "}
              {new Date(profile.created_at).toLocaleDateString("en-GB", {
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>
        </div>
      )}
    </CardContent>
  </Card>
);
